import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Ventas = () => {
  const [ventas, setVentas] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState("pagado");
  const [expandido, setExpandido] = useState(null);
  const [editandoId, setEditandoId] = useState(null);

  const estados = ["pagado", "pedido", "en taller", "entregado"];
  const iconos = {
    pagado: "bi-currency-dollar",
    pedido: "bi-phone",
    "en taller": "bi-tools",
    entregado: "bi-box-seam",
    todos: "bi-list-ul",
  };

  const fetchVentas = async () => {
    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/get_ventas.php",
        {
          credentials: "include",
        },
      );
      const data = await resp.json();
      if (Array.isArray(data)) setVentas(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVentas();
  }, []);

  const getEstadoColor = (estado) => {
    switch (estado?.toLowerCase()) {
      case "pagado":
        return "#dc3545";
      case "pedido":
        return "#fd7e14";
      case "en taller":
        return "#ffc107";
      case "entregado":
        return "#198754";
      default:
        return "#6c757d";
    }
  };

  const formatGrad = (e, c, a, add) => {
    const esf = parseFloat(e) || 0;
    const cil = parseFloat(c) || 0;
    const eje = parseInt(a) || 0;
    const adicion = parseFloat(add) || 0;
    const sign = (num) => (num > 0 ? "+" : "");
    let res = "";
    if (esf !== 0 || cil !== 0) {
      res = `${sign(esf)}${esf.toFixed(2)} (${sign(cil)}${cil.toFixed(2)}) ${eje}°`;
    }
    if (adicion !== 0) res += ` [Add ${sign(adicion)}${adicion.toFixed(2)}]`;
    return res || "PLANO";
  };

  const cambiarEstado = async (id, nuevoEstado) => {
    try {
      // RESET DE ESTADOS VISUALES: Esto evita que la ficha quede abierta al cambiar de lado
      setExpandido(null);
      setEditandoId(null);

      const formData = new FormData();
      formData.append("id", id);
      formData.append("estado", nuevoEstado);
      const resp = await fetch(
        "https://optimarketok.com.ar/api/update_estado_venta.php",
        {
          method: "POST",
          body: formData,
          credentials: "include",
        },
      );
      const res = await resp.json();
      if (res.success) {
        fetchVentas();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const parseImagen = (imagenes) => {
    if (!imagenes) return null;
    try {
      const parsed =
        typeof imagenes === "string" ? JSON.parse(imagenes) : imagenes;
      const item = Array.isArray(parsed) ? parsed[0] : parsed;
      const nombre =
        typeof item === "object" && item !== null
          ? item.name || item.url
          : String(item);
      return nombre
        ? `https://optimarketok.com.ar/imagenes/${encodeURIComponent(nombre.trim())}`
        : null;
    } catch (e) {
      return null;
    }
  };

  const filtered = ventas.filter(
    (v) =>
      (v.nombre_cliente || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) &&
      (filtroEstado === "todos" || v.estado?.toLowerCase() === filtroEstado),
  );

  if (isLoading)
    return (
      <div className="p-5 text-center text-muted small">Cargando taller...</div>
    );

  return (
    <div className="container-fluid mt-2 pb-5">
      <style>{`
        .desktop-table { display: none; }
        .mobile-list { display: block; }
        @media (min-width: 992px) {
          .desktop-table { display: table; width: 100%; }
          .mobile-list { display: none; }
          .container-fluid { max-width: 1200px !important; }
        }
        .grad-text { font-size: 0.85rem; color: #444; font-weight: 500; }
        .btn-move { width: 50px; height: 38px; border: none; display: flex; align-items: center; justify-content: center; transition: all 0.2s; }
        .status-indicator { width: 4px; height: 100%; position: absolute; left: 0; top: 0; }
        .tab-btn { flex: 1; min-width: 45px; display: flex; flex-direction: column; align-items: center; padding: 4px 0; border-radius: 8px; cursor: pointer; }
        .tab-icon { font-size: 1.2rem; line-height: 1; }
        .tab-count { font-size: 0.65rem; font-weight: bold; margin-top: 2px; }
        .btn-edit-sutil { background: none; border: none; color: #ccc; padding: 5px; transition: color 0.2s; }
        .btn-edit-sutil:hover { color: #666; }
      `}</style>

      {/* BUSCADOR */}
      <div
        className="d-flex justify-content-between align-items-center mb-2 gap-2 mx-auto"
        style={{ maxWidth: "800px" }}
      >
        <input
          type="text"
          className="form-control form-control-sm border-0 shadow-sm"
          placeholder="Buscar cliente..."
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Link to="/admin" className="btn btn-sm btn-dark shadow-sm px-3">
          Admin
        </Link>
      </div>

      {/* TABS */}
      <div
        className="d-flex justify-content-between mb-3 gap-1 mx-auto"
        style={{ maxWidth: "800px" }}
      >
        {["pagado", "pedido", "en taller", "entregado", "todos"].map((est) => (
          <div
            key={est}
            onClick={() => setFiltroEstado(est)}
            className={`tab-btn border-0 ${filtroEstado === est ? "text-white shadow-sm" : "bg-white text-muted shadow-sm"}`}
            style={{
              backgroundColor:
                filtroEstado === est ? getEstadoColor(est) : "white",
            }}
          >
            <i className={`bi ${iconos[est]} tab-icon`}></i>
            <span className="tab-count">
              {
                ventas.filter((v) =>
                  est === "todos" ? true : v.estado?.toLowerCase() === est,
                ).length
              }
            </span>
          </div>
        ))}
      </div>

      {/* --- VISTA MOBILE --- */}
      <div className="mobile-list mx-auto" style={{ maxWidth: "600px" }}>
        <div className="rounded shadow-sm border bg-white overflow-hidden">
          {filtered.map((v) => {
            const idx = estados.indexOf(v.estado.toLowerCase());
            const isExpanded = expandido === v.id;
            const isEditing = editandoId === v.id;

            return (
              <div
                key={v.id}
                className="border-bottom"
                style={{ position: "relative" }}
              >
                <div
                  className="status-indicator"
                  style={{ backgroundColor: getEstadoColor(v.estado) }}
                ></div>

                <div
                  className="d-flex align-items-center p-2 ps-3"
                  onClick={() => {
                    setExpandido(isExpanded ? null : v.id);
                    setEditandoId(null);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="me-3"
                    onClick={(e) => e.stopPropagation()}
                    style={{ width: "70px", height: "46px", flexShrink: 0 }}
                  >
                    <img
                      src={
                        parseImagen(v.imagenes) ||
                        "https://via.placeholder.com/70x46"
                      }
                      className="rounded border w-100 h-100"
                      style={{ objectFit: "cover" }}
                      alt=""
                    />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      className="fw-bold text-uppercase"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {v.nombre_cliente}
                    </div>
                    <div
                      className="text-muted text-truncate"
                      style={{ fontSize: "0.7rem" }}
                    >
                      {v.producto}
                    </div>
                  </div>
                  <div className="d-flex gap-1">
                    {idx < estados.length - 1 && (
                      <button
                        className="btn-move rounded shadow-sm text-white"
                        onClick={(e) => {
                          e.stopPropagation();
                          cambiarEstado(v.id, estados[idx + 1]);
                        }}
                        style={{
                          backgroundColor: getEstadoColor(estados[idx + 1]),
                        }}
                      >
                        <i className={`bi ${iconos[estados[idx + 1]]}`}></i>
                      </button>
                    )}
                  </div>
                </div>

                {isExpanded && (
                  <div className="p-3 bg-light border-top">
                    <div className="row g-2">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <div>
                          {/* <small className="text-muted d-block x-small fw-bold">
                            MARCO
                          </small> */}
                          <span className="small">{v.marco}</span>
                        </div>
                        <a
                          href={v.pdf_url}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-outline-danger btn-sm border-0 fw-bold"
                          style={{ fontSize: "0.7rem" }}
                        >
                          VER FICHA
                        </a>
                      </div>

                      <div className="col-12 mt-1">
                        <div className="bg-white p-2 rounded border grad-text shadow-sm mb-2">
                          <div className="d-flex justify-content-between border-bottom pb-1 mb-1">
                            <span
                              style={{
                                color: getEstadoColor(v.estado),
                                fontWeight: "bold",
                              }}
                            >
                              OD
                            </span>
                            <span>
                              {formatGrad(v.od_e, v.od_c, v.od_a, v.adicion)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span
                              style={{
                                color: getEstadoColor(v.estado),
                                fontWeight: "bold",
                              }}
                            >
                              OI
                            </span>
                            <span>
                              {formatGrad(v.oi_e, v.oi_c, v.oi_a, v.adicion)}
                            </span>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end align-items-center gap-2">
                          {isEditing ? (
                            <div className="d-flex gap-2 align-items-center w-100">
                              <Link
                                to={`/admin/editar-venta/${v.id}`}
                                className="btn btn-dark btn-sm shadow-sm"
                                style={{ fontSize: "0.65rem" }}
                              >
                                EDITAR TODO
                              </Link>
                              <select
                                className="form-select form-select-sm border-0 shadow-sm"
                                autoFocus
                                value={v.estado.toLowerCase()}
                                onChange={(e) =>
                                  cambiarEstado(v.id, e.target.value)
                                }
                                style={{ fontSize: "0.7rem", flex: 1 }}
                              >
                                {estados.map((e) => (
                                  <option key={e} value={e}>
                                    {e.toUpperCase()}
                                  </option>
                                ))}
                              </select>
                              <button
                                className="btn btn-sm btn-light border"
                                onClick={() => setEditandoId(null)}
                              >
                                <i className="bi bi-x"></i>
                              </button>
                            </div>
                          ) : (
                            <button
                              className="btn-edit-sutil"
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditandoId(v.id);
                              }}
                            >
                              <i className="bi bi-gear-fill"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* --- VISTA DESKTOP --- */}
      <div className="desktop-table shadow-sm rounded border bg-white overflow-hidden">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr style={{ fontSize: "0.8rem" }}>
              <th style={{ width: "6px", padding: 0 }}></th>
              <th>Foto</th>
              <th>Cliente / Armazón</th>
              <th>Cristal</th>
              <th>Receta</th>
              <th className="text-center">Ficha</th>
              <th className="text-center">Avanzar</th>
              <th className="text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((v) => {
              const idx = estados.indexOf(v.estado.toLowerCase());
              return (
                <tr key={v.id}>
                  <td
                    style={{
                      backgroundColor: getEstadoColor(v.estado),
                      padding: 0,
                    }}
                  ></td>
                  <td>
                    <img
                      src={
                        parseImagen(v.imagenes) ||
                        "https://via.placeholder.com/70x46"
                      }
                      className="rounded border shadow-sm"
                      style={{
                        width: "70px",
                        height: "46px",
                        objectFit: "cover",
                      }}
                      alt=""
                    />
                  </td>
                  <td>
                    <div className="fw-bold small">{v.nombre_cliente}</div>
                    <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                      {v.marco}
                    </div>
                  </td>
                  <td className="small text-muted">{v.producto}</td>
                  <td className="grad-text">
                    <div>
                      <span
                        style={{
                          color: getEstadoColor(v.estado),
                          fontWeight: "bold",
                        }}
                      >
                        OD:
                      </span>{" "}
                      {formatGrad(v.od_e, v.od_c, v.od_a, v.adicion)}
                    </div>
                    <div>
                      <span
                        style={{
                          color: getEstadoColor(v.estado),
                          fontWeight: "bold",
                        }}
                      >
                        OI:
                      </span>{" "}
                      {formatGrad(v.oi_e, v.oi_c, v.oi_a, v.adicion)}
                    </div>
                  </td>
                  <td className="text-center">
                    <a
                      href={v.pdf_url}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-outline-danger btn-sm border-0 fw-bold"
                    >
                      FICHA
                    </a>
                  </td>
                  <td className="text-center">
                    {idx < estados.length - 1 && (
                      <button
                        className="btn-move rounded shadow-sm text-white mx-auto"
                        onClick={() => cambiarEstado(v.id, estados[idx + 1])}
                        style={{
                          backgroundColor: getEstadoColor(estados[idx + 1]),
                        }}
                      >
                        <i className={`bi ${iconos[estados[idx + 1]]}`}></i>
                      </button>
                    )}
                  </td>
                  <td>
                    <select
                      className="form-select form-select-sm border-0 bg-light"
                      value={v.estado.toLowerCase()}
                      onChange={(e) => cambiarEstado(v.id, e.target.value)}
                      style={{ fontSize: "0.7rem" }}
                    >
                      {estados.map((e) => (
                        <option key={e} value={e}>
                          {e.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Ventas;
